export const capture_options = {
  audio: false,
  video: { facingMode: 'environment' }
};
